// import React,{Component} from "react";
// import {
//   Col,
//   Progress,
//   Input,
//   FormGroup,
//   Label
// } from "reactstrap";
// import "components/custom.css";
// import {store,persistor} from 'store/index';
// class Summary extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       question: "",
//       secondCount: 600,
//       // secondCount: 20,
//       questionId: "",
//       reset: false,
//       content: '',
//       lang: store.getState().user.lang,
//       resultObj: {},
//       correctFlag: true,
//       timeoutStat: false,
//       showTimer: true,
//     };
//   }
//   componentDidMount() {
//   	var intervalId = setInterval(this.timer, 1000);
//     const { isQuestionTime, questionTime } = this.props;
//     if (isQuestionTime) {
//       this.setState({
//         secondCount: questionTime * 60,
//         showTimer: isQuestionTime,
//       });
//     }
//     this.setState({intervalId: intervalId});

//   }
//   copyToClipboard = () => {
//     document.execCommand("copy");
//   };

//   cutToClipboard = () => {
//     document.execCommand("cut");
//   };

//   pasteToClipboard = async () => {
//     alert("Press Ctrl+v for paste text");

//   };

//   static getDerivedStateFromProps(props, state) {
//   	if (props.data) {
//   		if ((state.questionId && state.questionId !== props.data.id) || props.restart) {
//   			clearInterval(state.intervalId);
//   			clearInterval(state.recordId);
//         const { isQuestionTime, questionTime } = props;
//         let secondState = { secondCount: 600, showTimer: true };
//         if (isQuestionTime) {
//           secondState = {
//             secondCount: questionTime * 60,
//             showTimer: isQuestionTime,
//           };
//         }
//   			return {timeoutStat:false,correctFlag:true,...secondState,questionId: props.data.id,reset:true,content:''};
//   		}else{
//   			if (!state.questionId) {
//   				return {correctFlag:true,questionId: props.data.id,content:''};
//   			}
//   		}
//   	}
//   }

// 	timer = () => {
// 		if (this.state.secondCount === 1) {
// 			clearInterval(this.state.intervalId);
//       this.setState({timeoutStat:true});
//       if (this.state.showTimer) {
//         this.props.nextQuestionHandler();
//       }
// 		}
// 		this.setState({ secondCount: this.state.secondCount -1 });
// 	}

// 	componentWillUnmount = () => {
// 		clearInterval(this.state.intervalId);
// 	}
//   chaneText = (e) =>{
//     let { name, value } = e.target;
//     this.props.showResult();
//     this.props.submit({'answer':value,'correct':'','length':value.split(' ').filter(function(n) { return n != '' }).length,'time':this.state.secondCount,lang:this.state.lang},true);
//     this.setState({ [name] : value, resultObj: {'answer':value,'correct':'','length':value.split(' ').filter(function(n) { return n != '' }).length,'time':this.state.secondCount,lang:this.state.lang} });
//   };
//   chaneLang = (e) => {
//     this.setState({lang:e.target.value});
//   }

//   stopTest = () =>{
//     this.props.nextQuestion({...this.state.resultObj,time:this.state.secondCount});
//   }

//   updateCorrect = () =>{
//     this.props.submit({'answer':'','correct':'','length':0,time:this.state.secondCount,lang:this.state.lang});
//     this.setState({correctFlag:false,resultObj:{'answer':'','correct':'','length':0,time:this.state.secondCount,lang:this.state.lang}});
//   }

//   copyFunc = () => {
// 	  return false;
//   }

//   render() {
//   	let question ="";
//     if (this.props.restart) {
//       this.props.restartQue();
//     }
//   	if (this.props.data) {
//   		question = this.props.data.question;
//       if (this.state.correctFlag) {
//         this.updateCorrect();
//       }
//   	}
//   	if (this.state.reset) {
//   		var intervalId = setInterval(this.timer, 1000);
// 		  this.setState({intervalId: intervalId,reset:false});
//   	}

//     if (this.props.stopRecording) {
//       this.stopTest();
//     }

//     return (
//       <>
//         <Col xs={12}>
//         	<h4 className="infoText"></h4>
//         </Col>
//         <Col xs={12}>
//         	<div>
//             <div>
//               <h5 className="para-form">{question}</h5>
//               {!this.props.resultMode && !this.props.answer &&
//                 <>
//                   <Col xs={12} className="text-right">
//                     <b>
//                       <p>
//                         <i className="fa fa-clock-o"></i> <span>Time Left: {Math.floor(this.state.secondCount / 60) +':'+ (this.state.secondCount % 60)}</span>
//                       </p>
//                     </b>
//                   </Col>

//                   <Col xs={2} style={{margin:'10px'}}></Col>

//                   <div>
//                     <FormGroup>
//                       {!this.state.timeoutStat &&
//                         <Input
//                           type="textarea"
//                           onCopy={this.copyFunc}
//                           autoCorrect="false"
//                           spellCheck="false"
//                           name="content"
//                           onChange={(e) => { this.chaneText(e)}}
//                           value={this.state.content}
//                         />
//                       }

//                       {this.state.timeoutStat &&
//                         <div className="timeout-box">{this.state.content}</div>
//                       }
//                     </FormGroup>
//                     <div className="bottomContent">
//                       <div className="copyPaste">
//                         <a
//                           href="javascript:void(0)"
//                           onClick={this.cutToClipboard}
//                           className="btn"
//                         >Cut</a>

//                         <a
//                           href="javascript:void(0)"
//                           onClick={this.copyToClipboard}
//                           className="btn"
//                         >Copy</a>

//                         <a
//                           href="javascript:void(0)"
//                           onClick={this.pasteToClipboard}
//                           className="btn"
//                         >Paste</a>
//                       </div>

//                       <p className="wordCount">Total word count: {this.state.content.split(' ').filter(function(n) { return n != '' }).length}</p>
//                     </div>
//                   </div>
//                 </>
//               }
//             </div>
//       		</div>
//         </Col>
//       </>
//     );
//   }
// }
// export default Summary;


import React, { useState, useEffect, useRef } from "react";

import {Col , Form} from "react-bootstrap";
import "components/custom.css";
import { store, persistor } from 'store/index';

const Summary = (props) => {
  // const [question, setQuestion] = useState("");
  const [secondCount, setSecondCount] = useState(600);
  const [questionId, setQuestionId] = useState("");
  const [reset, setReset] = useState(false);
  const [content, setContent] = useState('');
  const [lang, setLang] = useState(store.getState().user.lang);
  const [resultObj, setResultObj] = useState({});
  const [correctFlag, setCorrectFlag] = useState(true);
  const [timeoutStat, setTimeoutStat] = useState(false);
  const [showTimer, setShowTimer] = useState(true);
  const [intervalId, setIntervalId] = useState(null);

  const intervalIdRef = useRef(null);
  const recordIdRef = useRef(null);

  // Timer function
  const timer = () => {
    setSecondCount((prevCount) => {
      if (prevCount === 1) {
        clearInterval(intervalIdRef.current);
        setTimeoutStat(true);
        if (showTimer) {
          props.nextQuestionHandler();
        }
      }
      return prevCount - 1;
    });
  };

  // Initial mount effect (componentDidMount)
  useEffect(() => {
    console.log("Summarize of the MOck Test")
    console.log(props,"Here are the props")
    const interval = setInterval(timer, 1000);
    intervalIdRef.current = interval;
    setIntervalId(interval);

    const { isQuestionTime, questionTime } = props;
    if (isQuestionTime) {
      setSecondCount(questionTime * 60);
      setShowTimer(isQuestionTime);
    }

    // Cleanup (componentWillUnmount)
    return () => {
      clearInterval(intervalIdRef.current);
    };
  }, []);

  // getDerivedStateFromProps equivalent
  useEffect(() => {
    if (props.data) {
      if ((questionId && questionId !== props.data.id) || props.restart) {
        clearInterval(intervalIdRef.current);
        clearInterval(recordIdRef.current);

        const { isQuestionTime, questionTime } = props;
        let secondState = { secondCount: 600, showTimer: true };
        if (isQuestionTime) {
          secondState = {
            secondCount: questionTime * 60,
            showTimer: isQuestionTime,
          };
        }

        setTimeoutStat(false);
        setCorrectFlag(true);
        setSecondCount(secondState.secondCount);
        setShowTimer(secondState.showTimer);
        setQuestionId(props.data.id);
        setReset(true);
        setContent('');
      } else {
        if (!questionId) {
          setCorrectFlag(true);
          setQuestionId(props.data.id);
          setContent('');
        }
      }
    }
  }, [props.data, props.restart, questionId]);

  // Reset timer effect
  useEffect(() => {
    if (reset) {
      const interval = setInterval(timer, 1000);
      intervalIdRef.current = interval;
      setIntervalId(interval);
      setReset(false);
    }
  }, [reset]);

  // Update correct effect
  useEffect(() => {
    if (props.data && correctFlag) {
      updateCorrect();
    }
  }, [props.data, correctFlag]);

  // Stop recording effect
  useEffect(() => {
    if (props.stopRecording) {
      stopTest();
    }
  }, [props.stopRecording]);

  // Restart effect
  useEffect(() => {
    if (props.restart) {
      props.restartQue();
    }
  }, [props.restart]);

  const copyToClipboard = () => {
    document.execCommand("copy");
  };

  const cutToClipboard = () => {
    document.execCommand("cut");
  };

  const pasteToClipboard = async () => {
    alert("Press Ctrl+v for paste text");
  };

  const chaneText = (e) => {
    let { name, value } = e.target;
    props.showResult();
    const wordCount = value.split(' ').filter(function (n) { return n != '' }).length;
    const result = {
      'answer': value,
      'correct': '',
      'length': wordCount,
      'time': secondCount,
      lang: lang
    };
    props.submit(result, true);
    setContent(value);
    setResultObj(result);
  };

  const chaneLang = (e) => {
    setLang(e.target.value);
  };

  const stopTest = () => {
    props.nextQuestion({ ...resultObj, time: secondCount });
  };

  const updateCorrect = () => {
    const result = {
      'answer': '',
      'correct': '',
      'length': 0,
      'time': secondCount,
      lang: lang
    };
    props.submit(result);
    setCorrectFlag(false);
    setResultObj(result);
  };

  const copyFunc = () => {
    return false;
  };

  let question = "";
  if (props.data) {
    question = props.data.question;
  }
  
  const totalSeconds = Math.max(0, Math.floor(secondCount));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return (
    <>
      <Col xs={12}>
        <h4 className="infoText"></h4>
      </Col>
      <Col xs={12}>
        <div>
          <div>
            <h5 className={props?.testMode ? "para-form" : "reading-text"}>{question}</h5>
            {!props.resultMode && !props.answer &&
              <>
                <Col xs={12} className="text-right">
                  <b>
                    <p>
                      {/* <i className="fa fa-clock-o"></i> <span>Time Left: {Math.floor(secondCount / 60) + ':' + (secondCount % 60)}</span> */}
                      <i className="fa fa-clock-o"></i> <span>Time Left:{` ${minutes}m:${seconds.toString().padStart(2, "0")}s`}</span>
                    </p>
                  </b>

                </Col>

                <Col xs={2} style={{ margin: '10px' }}></Col>

              <div className="pb-5" >
                <div className="bottomContent test-editor-blue">
                  <div className="copyPaste d-flex gap-2 mx-1 py-1">
                    <a
                      href="javascript:void(0)"
                      onClick={cutToClipboard}
                      className="btn"
                    >Cut</a>

                    <a
                      href="javascript:void(0)"
                      onClick={copyToClipboard}
                      className="btn"
                    >Copy</a>

                    <a
                      href="javascript:void(0)"
                      onClick={pasteToClipboard}
                      className="btn"
                    >Paste</a>
                  </div>
                </div>
                <Form.Group id="formGroupDiv" >
                  {!timeoutStat &&
                    <Form.Control
                      as="textarea"
                      onCopy={copyFunc}
                      autoCorrect="false"
                      spellCheck="false"
                      name="content"
                      onChange={(e) => { chaneText(e) }}
                      value={content}
                    />
                  }

                  {timeoutStat &&
                    <div className="timeout-box">{content}</div>
                  }
                </Form.Group>
                <div className="test-editor-blue bottomContent" >
                  <div className="copyPaste" >
                    <p className="wordCount text-white p-2">Total word count: {content.split(' ').filter(function (n) { return n != '' }).length}</p>
                  </div>
                </div>
              </div>
              </>
            }
          </div>
        </div>
      </Col>
    </>
  );
};

export default Summary;